import { UnavailabilityError } from 'expo';
import PushTokenManager from './PushTokenManager';
// @docsMissing
export async function unregisterForNotificationsAsync() {
    if (!PushTokenManager.unregisterForNotificationsAsync) {
        throw new UnavailabilityError('ExpoNotifications', 'unregisterForNotificationsAsync');
    }
    return PushTokenManager.unregisterForNotificationsAsync();
}

//# sourceMappingURL=unregisterForNotificationsAsync.js.map
